import { Tooltip } from "primereact/tooltip";
import { classNames } from "primereact/utils";

import { Icon } from "@/ds";

import { IconeBarco } from "../icone-barco";
import { TipoObraTags } from "../tipo-obra-tags";
import { OBRA_CARD_TOOLTIP_POSITIONS } from "./obra-card.constants";
import styles from "./obra-card.module.scss";
import type { ObraCardViewModel } from "./types-obra-card";

export function ObraCardView(vm: ObraCardViewModel) {
  return (
    <div
      className={classNames(styles.root, vm.className)}
      style={vm.style}
      data-testid={vm.testId}
      {...vm.rest}
      data-obra-card={vm.escopo}
    >
      <Tooltip target={vm.tooltipTarget} {...vm.tooltipProps} />

      <header className={styles.header}>
        <div className={styles.titulo}>
          <span className={styles.codigo}>{vm.codigo}</span>
          <span className={styles.embarcacao}>{vm.embarcacao}</span>
        </div>
        <span
          className={styles.icone}
          tabIndex={vm.icone.tabIndex}
          data-pr-tooltip={vm.icone.tooltip}
          data-pr-position={OBRA_CARD_TOOLTIP_POSITIONS.condicao}
        >
          <IconeBarco condicao={vm.icone.condicao} />
        </span>
      </header>

      <hr className={styles.divisor} />

      <div className={styles.datas}>
        <Icon name="calendar" size={14} />
        <span className={styles.periodo}>
          <span>{vm.inicio}</span>
          <span className={styles.seta} aria-hidden>
            →
          </span>
          <span>{vm.fim}</span>
        </span>
        <span className={styles.duracao}>
          <Icon name="clock" size={12} />
          {vm.duracao}
        </span>
      </div>

      <TipoObraTags tipos={vm.tipos} size="card" />

      <div className={styles.realizadoBloco}>
        <div className={styles.realizado}>
          <strong>{vm.realizadoLabel}</strong>
          <span>{vm.realizado}</span>
        </div>
        <div
          className={styles.barra}
          role="progressbar"
          aria-label={vm.realizadoLabel}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={vm.barra.valor}
          tabIndex={vm.barra.tooltip ? 0 : undefined}
          data-pr-tooltip={vm.barra.tooltip}
          data-pr-position={OBRA_CARD_TOOLTIP_POSITIONS.barra}
          data-testid={vm.barra.testId}
        >
          <span className={styles.barraValor} style={vm.barra.preenchimento} />
          <span className={styles.barraRotulo} data-fora={vm.barra.rotuloFora}>
            {vm.barra.rotulo}
          </span>
        </div>
      </div>

      <div className={styles.metricas}>
        {vm.metricas.map((metrica) => (
          <div key={metrica.key} className={styles.metrica}>
            <span
              className={styles.metricaRotulo}
              tabIndex={0}
              aria-label={metrica.nome}
              data-pr-tooltip={metrica.nome}
              data-pr-position={OBRA_CARD_TOOLTIP_POSITIONS.metrica}
              data-testid={metrica.testId}
            >
              {metrica.sigla}
              <Icon name="info-circle" size={12} />
            </span>
            <span className={styles.metricaValor}>{metrica.valor}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
